module.exports = __webpack_public_path__ + "img/axcess1_logo_v2.e6f6b652.png";